import React, { useState } from 'react';
import { 
  Share2, 
  Copy, 
  Mail, 
  Facebook, 
  Twitter, 
  Linkedin, 
  Link2, 
  Check,
  X 
} from 'lucide-react';

const ShareHubberModal = ({ url, onClose }) => {
  const [copied, setCopied] = useState(false);

  // Social Media Sharing URLs
  const getSocialShareUrl = (platform) => {
    const encodedUrl = encodeURIComponent(url);
    const text = encodeURIComponent("Check out this awesome link!");

    const platforms = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      whatsapp: `https://wa.me/?text=${text} ${encodedUrl}`,
      email: `mailto:?subject=Check out this link&body=${text} ${encodedUrl}`
    };

    return platforms[platform];
  };

  // Copy Link to Clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // Open Social Media Share
  const openShareLink = (platform) => {
    window.open(getSocialShareUrl(platform), '_blank');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div 
        className="bg-white w-96 rounded-2xl shadow-2xl p-6 relative animate-scale-in"
        role="dialog"
        aria-modal="true">
        
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close share modal"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Modal Header */}
        <div className="text-center mb-6">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <Share2 className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">Share Tuly</h2>
          <p className="text-sm text-gray-500 mt-2">with your community!</p>
        </div>

        {/* Link Copy Section */}
        <div className="flex items-center space-x-2 mb-6">
          <input 
            type="text" 
            value={url} 
            readOnly 
            className="flex-1 p-2 border rounded-lg text-sm truncate pr-10"
          />
          <button 
            onClick={copyToClipboard}
            className={`absolute right-8 p-2 rounded-full transition-colors ${
              copied 
                ? 'bg-green-500 text-white' 
                : 'bg-gray-200 hover:bg-gray-300'
            }`}
            aria-label="Copy link to clipboard"
          >
            {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
          </button>
        </div>

        {/* Social Share Buttons */}
        <div className="grid grid-cols-5 gap-3 justify-center">
          {[
            { 
              icon: Mail, 
              platform: 'email', 
              color: 'text-red-500 hover:bg-red-50' 
            },
            { 
              icon: Facebook, 
              platform: 'facebook', 
              color: 'text-blue-600 hover:bg-blue-50' 
            },
            { 
              icon: Twitter, 
              platform: 'twitter', 
              color: 'text-sky-500 hover:bg-sky-50' 
            },
            { 
              icon: Linkedin, 
              platform: 'linkedin', 
              color: 'text-blue-700 hover:bg-blue-50' 
            },
            { 
              icon: Link2, 
              platform: 'whatsapp', 
              color: 'text-green-600 hover:bg-green-50' 
            }
          ].map(({ icon: Icon, platform, color }) => (
            <button
              key={platform}
              onClick={() => openShareLink(platform)}
              className={`p-3 rounded-full flex items-center justify-center 
                          transition-all hover:scale-110 ${color}`}
              aria-label={`Share on ${platform}`}
            >
              <Icon className="w-6 h-6" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};


export default ShareHubberModal;

